import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './YourInformation.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import moment from 'moment-timezone'
import MasterNumber from './MasterNumber'
import EmailAddress from './EmailAddress'
// import ConfirmEmailAddress from './ConfirmEmailAddress'
import PhoneNumber from './PhoneNumber'
import { getmasterNumberValidAction } from 'redux/reducers/apiReducers/masterNumberValidatorReducer.js'
import { screenLoadingAction } from 'redux/actions'
import BackAnchor from '../../../../shared/components/BackAnchor'

const YourInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [masterNumberValid, setMasterNumberValid] = useState('')
  const [emailAddressValid, setEmailAddressValid] = useState('')
  // const [confirmEmailAddressValid, setConfirmEmailAddressValid] = useState('')
  const [phoneNumberValid, setPhoneNumberValid] = useState('')

  const [masterNumberError, setMasterNumberError] = useState('your_information.master_number_error')
  const [emailAddressError, setEmailAddressError] = useState('your_information.email_address_error')
  // const [confirmEmailAddressError, setConfirmEmailAddressError] = useState('your_information.confirm_email_address_error')
  const [phoneNumberError, setPhoneNumberError] = useState('your_information.phone_number_error')

  const masterNumber = useSelector((state) => state.yourInformation.masterNumber)
  const emailAddress = useSelector((state) => state.yourInformation.emailAddress)
  // const confirmEmailAddress = useSelector((state) => state.yourInformation.confirmEmailAddress)
  const phoneNumber = useSelector((state) => state.yourInformation.phoneNumber)

  const backNextProps = {
    prevText: t('your_information.back'),
    prevURL: `/${i18n.language}${t('routes.fines_question')}`,
    nextText: t('your_information.next'),
  }

  const validateMasterNumberBackend = () => {
    try {
      dispatch(screenLoadingAction())
      return dispatch(getmasterNumberValidAction(masterNumber))
        .then((res) => {
          dispatch(screenLoadingAction())
          return res['data']['responseCode']
        })
        .catch((e) => {
          dispatch(screenLoadingAction())
          console.log(e)
        })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const onNext = () => {
    try {
      if (validateFields()) {
        validateMasterNumberBackend()
          .then((responseCode) => {
            if (responseCode === 0) {
              history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
            } else if (responseCode === 1) {
              setMasterNumberValid(false)
              setMasterNumberError('your_information.master_number_error_invalid')
            } else if (responseCode === 2 || responseCode === 3) {
              history.push(`/${i18n.language}${t('routes.cannot_process_fee')}`)
            }
          })
          .catch((e) => {
            console.log(e)
          })
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      let masterNumberValid = false,
        emailAddressValid = false,
        phoneNumberValid = false
      // validateConfirmEmail(confirmEmailAddress)
      if (masterNumber === '') {
        setMasterNumberValid(masterNumberValid)
      } else {
        masterNumberValid = validateMasterNumber(masterNumber)
      }
      if (emailAddress === '') {
        setEmailAddressValid(emailAddressValid)
      } else {
        emailAddressValid = validateEmailAddress(emailAddress)
      }
      // if (confirmEmailAddress === '') {
      //   setConfirmEmailAddressValid(false)
      // }
      if (phoneNumber === '') {
        setPhoneNumberValid(phoneNumberValid)
      } else {
        phoneNumberValid = validatePhoneNumber(phoneNumber)
      }
      return masterNumberValid && emailAddressValid && phoneNumberValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateMasterNumber = (masterNumberElem) => {
    let masterNumberValid = false,
      masterNumberError = ''
    const regex = RegExp(/^[a-zA-Z0-9 ]{14}$/i)
    if (masterNumberElem.length > 0) {
      if (
        regex.test(masterNumberElem) &&
        !isNaN(masterNumberElem.substring(11))
      ) {
        masterNumberValid = true
      } else {
        masterNumberError = 'your_information.master_number_error_invalid'
      }
    } else {
      masterNumberError = 'your_information.master_number_error'
    }
    setMasterNumberValid(masterNumberValid)
    setMasterNumberError(masterNumberError)
    return masterNumberValid
  }

  const validateEmailAddress = (email) => {
    try {
      let emailAddressValid = false,
        emailAddressError = ''
      const regex = RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      if (email.length > 0) {
        if (regex.test(email)) {
          emailAddressValid = true
        } else {
          emailAddressError = 'your_information.email_address_error_invalid'
        }
      } else {
        emailAddressError = 'your_information.email_address_error'
      }
      setEmailAddressValid(emailAddressValid)
      setEmailAddressError(emailAddressError)
      return emailAddressValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  // const validateConfirmEmail = (confirmEmail) => {
  //   try {
  //     if (confirmEmail && confirmEmail === emailAddress) {
  //       setConfirmEmailAddressValid(true)
  //     } else {
  //       setConfirmEmailAddressValid(false)
  //       setConfirmEmailAddressError('your_information.confirm_email_address_error')
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }

  const validatePhoneNumber = (number) => {
    try {
      let phoneNumberValid = false,
        phoneNumberError = ''
      if (number.length > 0) {
        if (number.length === 12) {
          phoneNumberValid = true
        } else {
          phoneNumberError = 'your_information.phone_number_error_invalid'
        }
      } else {
        phoneNumberError = 'your_information.phone_number_error'
      }
      setPhoneNumberValid(phoneNumberValid)
      setPhoneNumberError(phoneNumberError)
      return phoneNumberValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <BackAnchor isInternal={true} backPath="routes.fines_question" />
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h1>{t('your_information.add_your_information')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <MasterNumber
            validateMasterNumber={validateMasterNumber}
            masterNumberError={masterNumberError}
            masterNumberValid={masterNumberValid}
            setIsError={setIsError}
          />
          <EmailAddress
            validateEmailAddress={validateEmailAddress}
            emailAddressError={emailAddressError}
            emailAddressValid={emailAddressValid}
            setIsError={setIsError}
          />
          {/* <ConfirmEmailAddress
            validateConfirmEmail={validateConfirmEmail}
            confirmEmailAddressError={confirmEmailAddressError}
            confirmEmailAddressValid={confirmEmailAddressValid}
            setIsError={setIsError}
          /> */}
          <PhoneNumber
            validatePhoneNumber={validatePhoneNumber}
            phoneNumberError={phoneNumberError}
            phoneNumberValid={phoneNumberValid}
            setIsError={setIsError}
          />
        </div>
      </div>
      <div className={styles['back_next_margin']}>
        <BackNextButtons props={backNextProps} nextOnClick={onNext} />
      </div>
    </div>
  )
}

export default withTranslation('common')(YourInformationView)
